import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SettingGet } from '../../services';

export const fetchSettingsGet = createAsyncThunk(
    'settingsGet/fetchSettingsGet',
    async () => {
        var data = localStorage.getItem('Settings')
        if (data) {
            return JSON.parse(data)
        }
        const response = await SettingGet()
        localStorage.setItem('Settings', JSON.stringify(response.result))
        return response.result
    }
);

const settingsGetSlice = createSlice({
    name: 'settingsGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingsGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSettingsGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSettingsGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default settingsGetSlice.reducer;
